@if (isCurrentUserSuperAdmin()) {

@if (isLoading()) {
<app-loader [overlay]="true" size="md" message="Loading users…" />
}

<app-page-header title="User Management" />

<app-notification-dialog [visible]="isNotificationVisible()" [message]="notificationMessage()"
  [type]="notificationType()" (closed)="isNotificationVisible.set(false)" />

<main id="main-content" aria-labelledby="user-management-title"
  class="flex flex-col xl:flex-row gap-8 px-6 py-8 md:py-6 bg-main-bg min-h-[calc(100vh-200px)] max-w-[1600px] mx-auto w-full">
  <div class="xl:flex-[3] flex flex-col gap-8">
    <app-card-panel title="Search User">

      <div class="px-8 py-4" role="search" (keydown)="onSearchKeydown($event)">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4.5 items-end">
          <div class="w-full">
            <label for="search-first-name" class="block text-[12px] font-bold text-slate-900 mb-2">First Name</label>
            <input id="search-first-name" type="text" [(ngModel)]="searchCriteria.firstName"
              aria-label="Filter by First Name"
              class="w-full px-4 py-1 text-sm border border-slate-500 rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all placeholder:text-slate-600" />
          </div>
          <div class="w-full">
            <label for="search-last-name" class="block text-[12px] font-bold text-slate-900 mb-2">Last Name</label>
            <input id="search-last-name" type="text" [(ngModel)]="searchCriteria.lastName"
              aria-label="Filter by Last Name"
              class="w-full px-4 py-1 text-sm border border-slate-500 rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all placeholder:text-slate-600" />
          </div>
          <div class="w-full">
            <label for="search-email" class="block text-[12px] font-bold text-slate-900 mb-2">Email ID</label>
            <input id="search-email" type="text" [(ngModel)]="searchCriteria.emailId" aria-label="Filter by Email ID"
              class="w-full px-4 py-1 text-sm border border-slate-500 rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all placeholder:text-slate-600" />
          </div>

          <div class="w-full relative">
            <label for="search-department" class="block text-[12px] font-bold text-slate-900 mb-2">Department</label>
            <div class="relative">
              <select id="search-department" [(ngModel)]="searchCriteria.department"
                (ngModelChange)="onSearchDepartmentChange()" aria-label="Filter by Department"
                class="w-full px-4 py-1 text-sm border border-slate-500 rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all appearance-none"
                [ngClass]="searchCriteria.department ? 'bg-primary/10 text-slate-900' : 'bg-white text-slate-700'">
                <option value="">--Please Select--</option>
                @for (dept of departments(); track dept.id) {
                <option [value]="dept.name">{{ dept.name }}</option>
                }
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none"
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <div class="w-full relative">
            <label for="search-institution" class="block text-[12px] font-bold text-slate-900 mb-2">Institution</label>
            <div class="relative">
              <select id="search-institution" [(ngModel)]="searchCriteria.institution"
                [disabled]="!searchCriteria.department" aria-label="Filter by Institution"
                class="w-full px-4 py-1 text-sm border border-slate-500 rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all appearance-none disabled:bg-slate-100/50 disabled:text-slate-500 disabled:cursor-not-allowed disabled:border-slate-300"
                [ngClass]="searchCriteria.institution ? 'bg-primary/10 text-slate-900' : 'bg-white text-slate-700'">
                <option value="">--Please Select--</option>
                @for (inst of searchInstitutions(); track inst.id) {
                <option [value]="inst.name">{{ inst.name }}</option>
                }
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none"
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <div class="w-full relative">
            <label for="search-status" class="block text-[12px] font-bold text-slate-900 mb-2">Status</label>
            <div class="relative">
              <select id="search-status" [(ngModel)]="searchCriteria.active" aria-label="Filter by Status"
                class="w-full px-4 py-1 text-sm border border-slate-500 rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all appearance-none"
                [ngClass]="searchCriteria.active ? 'bg-primary/10 text-slate-900' : 'bg-white text-slate-700'">
                <option value="">--Please Select--</option>
                <option value="Yes">Active</option>
                <option value="No">Inactive</option>
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none"
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <div class="w-full relative">
            <label for="search-super-admin" class="block text-[12px] font-bold text-slate-900 mb-2">Super Admin</label>
            <div class="relative">
              <select id="search-super-admin" [(ngModel)]="searchCriteria.superAdmin" aria-label="Filter by Super Admin"
                class="w-full px-4 py-1 text-sm border border-slate-500 rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all appearance-none"
                [ngClass]="searchCriteria.superAdmin ? 'bg-primary/10 text-slate-900' : 'bg-white text-slate-700'">
                <option value="">--Please Select--</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none"
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <!-- <div class="w-full">
            <label class="block text-[12px] font-bold text-transparent mb-2" aria-hidden="true">Alignment Spacer</label>
            <div class="flex items-center h-[46px]">
              <div class="flex items-center gap-3">
                <span class="text-[11px] font-bold uppercase tracking-wider text-slate-600">Super Admin Only</span>
                <label for="search-super-admin" class="relative inline-flex items-center cursor-pointer">
                  <input id="search-super-admin" type="checkbox" [(ngModel)]="searchCriteria.superAdmin"
                    class="sr-only peer" />
                  <div
                    class="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary shadow-inner">
                  </div>
                </label>
              </div>
            </div>
          </div> -->

          <div class="md:col-span-2 lg:col-span-3 flex justify-end gap-3 mt-2">
            <app-button label="Reset" ariaLabel="Reset Search" (clicked)="resetSearch()" />
            <app-button label="Search" ariaLabel="Search Users" (clicked)="onSearch()" />
          </div>
        </div>
      </div>
    </app-card-panel>

    <app-data-table title="User List" [columns]="tableColumns" [data]="paginatedUsers()" trackByKey="emailId"
      [selectedItem]="selectedUser()" selectedKey="emailId" [currentPage]="currentPage()" [totalPages]="totalPages()"
      [totalItems]="filteredUsers().length" [pageSize]="pageSize" itemLabel="users" (rowClick)="onSelectUser($event)"
      (deleteClick)="onDeleteUser($event)" (pageChange)="onPageChange($event)">
      <ng-template #cellTemplate let-item let-column="column">
        @switch (column) {
        @case ('name') {
        <div class="truncate whitespace-nowrap text-[12px] font-bold text-slate-700" [attr.title]="item.name">
          {{ item.name }}
        </div>
        }

        @case ('emailId') {
        <span class="truncate whitespace-nowrap text-[12px] font-medium text-slate-500" [attr.title]="item.emailId">
          {{ item.emailId }}
        </span>
        }

        @case ('department.name') {
        <span class="block w-full truncate whitespace-nowrap text-[12px] font-medium text-slate-600"
          [attr.title]="item.department?.name">
          {{ item.department?.name }}
        </span>
        }
        @case ('active') {
        <div class="flex items-center justify-center gap-2">
          <span class="text-[11px] font-bold uppercase"
            [class]="item.active === 'Yes' ? 'text-emerald-600' : 'text-slate-600'">{{ item.active }}</span>
        </div>
        }
        @case ('superAdmin') {
        <span class="text-[11px] font-bold uppercase" [class]="item.superAdmin ? 'text-primary' : 'text-slate-600'">
          {{ item.superAdmin ? 'Yes' : 'No' }}
        </span>
        }
        }
      </ng-template>
    </app-data-table>
  </div>

  <div
    class="xl:flex-[2] xl:self-start bg-white rounded-2xl shadow-sm border border-slate-500 flex flex-col overflow-hidden w-full max-w-full lg:max-w-2xl xl:max-w-none mx-auto">
    <div
      class="px-8 py-2 border-b border-slate-400 flex flex-col sm:flex-row sm:items-center justify-between gap-4 bg-white">
      <div>
        <h2 class="text-[18px] font-bold text-slate-800">Maintain User</h2>
      </div>

      <div class="flex items-center gap-3">
        <app-button label="Add User" ariaLabel="Add New User" (clicked)="onCreateUser()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4" />
          </svg>
        </app-button>

        @if (selectedUser() || isAddUser()) {
        <app-button label="Edit User" ariaLabel="Edit User" [disabled]="isEditUser()" (clicked)="onEditUser()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
        </app-button>
        }
      </div>
    </div>

    @if (selectedUser() || isAddUser()) {

    <div class="flex-1 overflow-y-auto px-8 py-8 space-y-5 transition-opacity" [class.opacity-80]="!isEditUser()"
      [class.pointer-events-none]="!isEditUser()" (keydown)="onFormKeydown($event)">
      <section>
        <div class="space-y-6">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div>
              <label for="form-first-name" class="block text-[12px] font-bold mb-2 transition-colors"
                [class]="isEditUser() ? 'text-slate-900' : 'text-slate-700'">First Name<span class="text-red-500"
                  aria-hidden="true"> *</span></label>
              <input id="form-first-name" type="text" [ngModel]="firstName()" (ngModelChange)="firstName.set($event)"
                [disabled]="!isEditUser()" aria-label="First Name" required aria-required="true"
                class="w-full px-4 py-1 text-[13px] border rounded-xl bg-slate-50/30 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none placeholder:text-slate-600 disabled:bg-slate-100/50 disabled:text-slate-500 disabled:cursor-default"
                [class]="isEditUser() ? 'border-slate-500' : 'border-slate-300'" />
            </div>
            <div>
              <label for="form-last-name" class="block text-[12px] font-bold mb-2 transition-colors"
                [class]="isEditUser() ? 'text-slate-900' : 'text-slate-700'">Last Name<span class="text-red-500"
                  aria-hidden="true"> *</span></label>
              <input id="form-last-name" type="text" [ngModel]="lastName()" (ngModelChange)="lastName.set($event)"
                [disabled]="!isEditUser()" aria-label="Last Name" required aria-required="true"
                class="w-full px-4 py-1 text-[13px] border rounded-xl bg-slate-50/30 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none placeholder:text-slate-400 disabled:bg-slate-100/50 disabled:text-slate-500 disabled:cursor-default"
                [class]="isEditUser() ? 'border-slate-500' : 'border-slate-300'" />
            </div>
            <div>
              <label for="form-email" class="block text-[12px] font-bold mb-2 transition-colors"
                [class]="isEditUser() ? 'text-slate-900' : 'text-slate-700'">Email ID<span class="text-red-500"
                  aria-hidden="true"> *</span></label>
              <input id="form-email" type="email" [ngModel]="emailId()" (ngModelChange)="emailId.set($event)"
                [readonly]="!isEditUser() || !isAddUser()" aria-label="Email Address" required aria-required="true"
                class="w-full px-4 py-1 text-[13px] border rounded-xl bg-slate-50/30 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none placeholder:text-slate-600 disabled:bg-slate-100 disabled:text-slate-600 readonly:bg-slate-100/50 readonly:text-slate-600"
                [class]="isEditUser() ? 'border-slate-500' : 'border-slate-300'" />
              @if (emailId() && !isEmailValid()) {
              <p
                class="text-[11px] font-bold text-red-500 mt-1.5 ml-1 animate-in fade-in slide-in-from-top-1 duration-200">
                @if (userType() === 'Internal') {
                Internal users must use an <strong>@encoura.org</strong> email address.
                } @else {
                Please enter a valid email address.
                }
              </p>
              }
              @if (isEditUser() && !isAddUser()) {
              <p class="text-[11px] font-medium text-slate-500 mt-1.5 ml-1">
                Email cannot be edited for an existing user.
              </p>
              }
            </div>

            <div>
              <label class="block text-[12px] font-bold mb-2 transition-colors"
                [class]="isEditUser() ? 'text-slate-900' : 'text-slate-700'">User Type</label>
              <div class="flex rounded-xl border overflow-hidden bg-slate-50 p-0 h-[32px] transition-colors"
                role="group" aria-label="User Type Selection"
                [class]="isEditUser() ? 'border-slate-500' : 'border-slate-300'">
                <button (click)="onUserTypeChange('Internal')" [disabled]="!isEditUser()" 
                 [attr.aria-pressed]="userType() === 'Internal' ? 'true' : 'false'" aria-label="Filter by User Type: Internal"
                  class="flex-1 px-4 py-2 text-[11px] font-black uppercase tracking-wider rounded-lg transition-all disabled:cursor-default"
                  [class]="userType() === 'Internal' ? 'bg-primary shadow-sm text-white' : (isEditUser() ? 'text-slate-600 hover:text-slate-800' : 'text-slate-500')">
                  Internal
                </button>
                <button (click)="onUserTypeChange('External')" [disabled]="!isEditUser()"
                  [attr.aria-pressed]="userType() === 'External' ? 'true' : 'false'" aria-label="Filter by User Type: External"
                  class="flex-1 px-4 py-2 text-[11px] font-black uppercase tracking-wider rounded-lg transition-all disabled:cursor-default"
                  [class]="userType() === 'External' ? 'bg-primary shadow-sm text-white' : (isEditUser() ? 'text-slate-600 hover:text-slate-800' : 'text-slate-500')">
                  External
                </button>
              </div>
            </div>
          </div>
          <!-- /* Commenting out SSO ID field for now as it's not in use, but keeping the code for future reference if needed */ -->
          <!-- <div class="sm:col-span-2">
              <label for="form-sso-id" class="block text-[12px] font-bold text-slate-700 mb-2">SSO ID
                <span class="text-red-500" aria-hidden="true">*</span></label>
              <input id="form-sso-id" type="text" [ngModel]="loginSsoId()"
                (ngModelChange)="loginSsoId.set($event)" [readonly]="!isEditUser()" aria-label="Login SSO ID"
                required aria-required="true" placeholder="Enter SSO ID"
                class="w-full px-4 py-3 text-[13px] border border-slate-300 rounded-xl bg-slate-50/30 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none placeholder:text-slate-400 readonly:bg-slate-100/50 readonly:text-slate-500" />
            </div> -->
        </div>
      </section>

      <section class="grid grid-cols-1 sm:grid-cols-2 gap-8 py-2">
        <label class="flex items-center justify-between p-4 py-1 rounded-2xl border bg-slate-50/30 transition-colors"
          [class]="isEditUser() ? 'border-slate-500 cursor-pointer' : 'border-slate-300 cursor-default'">
          <span class="text-[12px] font-bold transition-colors"
            [class]="isEditUser() ? 'text-slate-900' : 'text-slate-800'">Active</span>
          <span class="relative inline-flex items-center">
            <input type="checkbox" [ngModel]="isActive()" (ngModelChange)="isActive.set($event)"
              [disabled]="!isEditUser()" class="sr-only peer" aria-label="Active Status" />
            <span
              class="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary shadow-inner">
            </span>
          </span>
        </label>

        <label class="flex items-center justify-between p-4 py-1 rounded-2xl border bg-slate-50/30 transition-all"
          [class]="(!isEditUser() || userType() === 'External') ? 'opacity-50 border-slate-300 cursor-default' : 'border-slate-500 cursor-pointer'">
          <span class="text-[12px] font-bold transition-colors"
            [class]="isEditUser() ? 'text-slate-900' : 'text-slate-800'">Super Admin</span>
          <span class="relative inline-flex items-center">
            <input type="checkbox" [ngModel]="isSuperAdmin()" (ngModelChange)="onSuperAdminChange($event)"
              [disabled]="!isEditUser() || userType() === 'External'" class="sr-only peer" aria-label="Super Admin" />
            <span
              class="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary shadow-inner">
            </span>
          </span>
        </label>
      </section>

  @if (canAllowAllAccess()) {
    <section class="py-2">

      <!-- Header -->
      <label
        class="flex items-center justify-between rounded-xl border border-slate-200 bg-slate-50/30 px-4 py-2.5"
        [class.cursor-pointer]="isEditUser()"
        [class.cursor-default]="!isEditUser()">

        <span class="flex min-w-0 items-center gap-2">
          <span class="text-[12px] font-bold text-slate-900">
            Allow access to all Departments/Institutions
          </span>

          <!-- Info icon -->
        <span class="relative group inline-flex items-center cursor-pointer">

        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9.5" stroke="currentColor" stroke-width="2"/>
        <path d="M12 10.5V16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <circle cx="12" cy="7.5" r="1" fill="currentColor"/>
        </svg>

      <span
        class="pointer-events-none absolute left-1/2 bottom-full z-50 mb-2
              hidden -translate-x-1/2 whitespace-nowrap rounded-md
              bg-slate-800 px-2.5 py-1.5 text-[11px] font-medium
              text-white shadow-lg group-hover:block">
        Allow this user to access all departments and institutions.
      </span>

      </span>
      </span>
        <!-- Toggle -->
        <span class="relative inline-flex shrink-0 items-center">
          <input
            type="checkbox"
            [ngModel]="allowAllAccess()"
            (ngModelChange)="onAllowAllAccessChange($event)"
            [disabled]="!isEditUser()"
            class="sr-only peer"
            aria-label="Allow access to all Departments and Institutions" />

          <span
            class="relative h-6 w-11 rounded-full bg-slate-200
                  shadow-inner transition-colors
                  peer-checked:bg-primary
                  peer-focus:outline-none
                  after:absolute after:left-[2px] after:top-[2px]
                  after:h-5 after:w-5 after:rounded-full
                  after:bg-white after:shadow-sm
                  after:transition-all
                  peer-checked:after:translate-x-full">
          </span>
        </span>
      </label>

      <!-- Information message -->
      @if (allowAllAccess()) {
        <div
          class="mt-2 flex items-start gap-3 rounded-xl bg-blue-50 px-4 py-3">

          <!-- Info icon -->
          <span class="mt-0.5 shrink-0 text-blue-600">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="9.5" stroke="currentColor" stroke-width="2"/>
              <path d="M12 10.5V16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <circle cx="12" cy="7.5" r="1" fill="currentColor"/>
            </svg>
          </span>

          <div class="min-w-0">
            <p class="text-[12px] font-medium leading-5 text-slate-800">
              This user will have access to all departments and institutions.
            </p>

            <p class="text-[12px] font-medium leading-5 text-slate-700">
              Department and institution mapping are not required.
            </p>
          </div>

        </div>
      }

    </section>
  }

      @if (!isSuperAdmin()) {
      <section class="py-2">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
          @if (!allowAllAccess()) {
          <div class="w-full relative">
            <label for="form-department" class="block text-[12px] font-bold mb-2 transition-colors"
              [class]="isEditUser() ? 'text-slate-900' : 'text-slate-700'">Department<span class="text-red-500"
                aria-hidden="true"> *</span></label>
            <div class="relative">
              <select id="form-department" [ngModel]="department()?.id || ''"
                (ngModelChange)="onDepartmentChange($event)" [disabled]="!isEditUser()" aria-label="Department"
                class="w-full px-4 py-1 text-[13px] border rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none disabled:bg-slate-100/50 disabled:text-slate-500 disabled:cursor-default appearance-none"
                [ngClass]="department()?.id ? 'bg-primary/10 text-slate-900' : 'bg-slate-50/30 text-slate-700'"
                [class]="isEditUser() ? 'border-slate-500' : 'border-slate-300'">
                <option value="">--Please Select--</option>
                @for (dept of departments(); track dept.id) {
                <option [value]="dept.id">{{ dept.name }}</option>
                }
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none"
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          }
          <div class="w-full relative">
            <label for="form-role" class="block text-[12px] font-bold mb-2 transition-colors"
              [class]="isEditUser() ? 'text-slate-900' : 'text-slate-700'">Role
              @if (!isSuperAdmin()) {
                <span class="text-red-500" aria-hidden="true"> *</span>
              }
            </label>
            <div class="relative">
              <select id="form-role" [ngModel]="selectedRole()?.id || ''"
                (ngModelChange)="selectedRole.set(activeRoles().find(r => r.id === $event) ? { id: $event, name: activeRoles().find(r => r.id === $event)!.roleName } : null)"
                [disabled]="!isEditUser() || isSuperAdmin()" aria-label="Role"
                class="w-full px-4 py-1 text-[13px] border rounded-xl bg-slate-50/30 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none disabled:bg-slate-100/50 disabled:text-slate-500 disabled:cursor-default appearance-none"
                [class]="isEditUser() && !isSuperAdmin() ? 'border-slate-500' : 'border-slate-300'">
                <option value="">--Please Select--</option>
                @if (selectedRole()?.id && !activeRoles().find(r => r.id === selectedRole()?.id)) {
                  <option [value]="selectedRole()!.id" class="text-slate-400">{{ selectedRole()!.name }} (Inactive - Cannot be reassigned)</option>
                }
                @for (role of activeRoles(); track role.id) {
                <option [value]="role.id">{{ role.roleName }}</option>
                }
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none"
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>
        </div>
      </section>

      @if (!allowAllAccess()) {
      <section>
        <div class="flex items-center gap-3 text-[13px] font-black text-slate-800 uppercase tracking-widest mb-3">
          <div class="w-8 h-8 bg-slate-50 rounded-lg flex items-center justify-center">
            <svg class="w-5 h-5 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          Institutional Permissions<span class="text-red-500" aria-hidden="true">*</span>
        </div>

        <app-institution-transfer-list [availableInstitutions]="availableInstitutions()"
          [assignedInstitutions]="assignedInstitutions()" [selectedAvailable]="selectedAvailable()"
          [selectedAssigned]="selectedAssigned()" [isEditable]="isEditUser()" idPrefix="report-management"
          (availableSelectedToggle)="toggleAvailableSelection($event)"
          (assignedSelectedToggle)="toggleAssignedSelection($event)" (moveToAssignedClick)="moveToAssigned()"
          (moveAllToAssignedClick)="moveAllToAssigned()" (moveAllToAvailableClick)="moveAllToAvailable()"
          (moveToAvailableClick)="moveToAvailable()" (availableKeydown)="onAvailableInstitutionsKeydown($event)"
          (assignedKeydown)="onAssignedInstitutionsKeydown($event)" (availableListBlur)="selectedAvailable.set([])"
          (assignedListBlur)="selectedAssigned.set([])" />
      </section>
      }
      }
    </div>

    @if (isEditUser()) {
    <div class="px-10 py-4 border-t border-slate-300 flex items-center justify-end gap-3 bg-slate-50/10">
      <app-button label="Cancel" (clicked)="onCancel()" />
      <app-button label="Save" [disabled]="!isFormValid()" (clicked)="onSave()" />
    </div>
    }
    }
  </div>
</main>
} @else {
<div class="flex items-center justify-center min-h-[calc(100vh-200px)]">
  <div class="text-center p-12 bg-white rounded-3xl shadow-xl border border-slate-300 max-w-md">
    <div class="w-20 h-20 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
      <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 15v2m0-6V9m0 12a9 9 0 110-18 9 9 0 010 18z" />
      </svg>
    </div>
    <h2 class="text-2xl font-black text-slate-800 mb-4">Access Denied</h2>
    <p class="text-slate-600 font-medium leading-relaxed mb-8">
      This screen is restricted to Super Admins only. Please contact your system administrator if you believe this is an
      error.
    </p>
    <button onclick="window.history.back()"
      class="px-6 py-2.5 bg-gradient-primary text-white text-[13px] font-bold rounded-xl hover:scale-105 transition-all shadow-md active:scale-95">
      Go Back
    </button>
  </div>
</div>
}

<app-confirm-dialog [visible]="showDeleteModal()"
  [message]="'Are you sure you want to delete ' + (userToDelete()?.name || '') + '?'" (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()" />